module.exports = function isSamePosition(point1, point2) {
    var dx = Math.abs(point1.x - point2.x);
    var dy = Math.abs(point1.y - point2.y);

    return (dx < 1e-8 && dy < 1e-8);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/ngraph.quadtreebh/isSamePosition.js
// module id = 611
// module chunks = 0